import type {
  CustomerDetailDto,
  CustomerDto,
  FollowUpTaskDto,
  TimelineItemDto,
} from "@grizzly/shared";
import { request } from "../http.js";

export const crmApi = {
  listCustomers: (params: { search?: string; status?: string } = {}) => {
    const query = new URLSearchParams();
    query.set("limit", "100");
    if (params.search) query.set("search", params.search);
    if (params.status) query.set("status", params.status);
    return request<{ items: CustomerDto[] }>(`/customers?${query.toString()}`);
  },
  getCustomer: (id: string) =>
    request<{ customer: CustomerDetailDto }>(`/customers/${id}`),
  createCustomer: (input: {
    legalName: string;
    displayName?: string;
    phone?: string;
    email?: string;
    notes?: string;
  }) => request<{ customer: CustomerDto }>("/customers", { method: "POST", body: input }),
  archiveCustomer: (id: string) =>
    request<{ customer: CustomerDto }>(`/customers/${id}/archive`, {
      method: "POST",
      body: {},
    }),
  unarchiveCustomer: (id: string) =>
    request<{ customer: CustomerDto }>(`/customers/${id}/unarchive`, {
      method: "POST",
      body: {},
    }),
  addContact: (customerId: string, input: object) =>
    request<{ contact: unknown }>(`/customers/${customerId}/contacts`, {
      method: "POST",
      body: input,
    }),
  updateContact: (customerId: string, contactId: string, input: object) =>
    request<{ contact: unknown }>(
      `/customers/${customerId}/contacts/${contactId}/update`,
      {
        method: "POST",
        body: input,
      }
    ),
  deleteContact: (customerId: string, contactId: string) =>
    request<{ ok: boolean }>(`/customers/${customerId}/contacts/${contactId}/delete`, {
      method: "POST",
      body: {},
    }),
  addAddress: (customerId: string, input: object) =>
    request<{ address: unknown }>(`/customers/${customerId}/addresses`, {
      method: "POST",
      body: input,
    }),
  updateAddress: (customerId: string, addressId: string, input: object) =>
    request<{ address: unknown }>(
      `/customers/${customerId}/addresses/${addressId}/update`,
      {
        method: "POST",
        body: input,
      }
    ),
  deleteAddress: (customerId: string, addressId: string) =>
    request<{ ok: boolean }>(`/customers/${customerId}/addresses/${addressId}/delete`, {
      method: "POST",
      body: {},
    }),
  recordActivity: (customerId: string, input: object) =>
    request<{ activity: unknown }>(`/customers/${customerId}/activities`, {
      method: "POST",
      body: input,
    }),
  getTimeline: (customerId: string) =>
    request<{ items: TimelineItemDto[] }>(`/customers/${customerId}/timeline`),
  listTasks: (
    params: { assignee?: string; customerId?: string; status?: string } = {}
  ) => {
    const query = new URLSearchParams();
    query.set("limit", "100");
    if (params.assignee) query.set("assignee", params.assignee);
    if (params.customerId) query.set("customerId", params.customerId);
    if (params.status) query.set("status", params.status);
    return request<{ items: FollowUpTaskDto[] }>(`/follow-up-tasks?${query.toString()}`);
  },
  createTask: (input: object) =>
    request<{ task: FollowUpTaskDto }>("/follow-up-tasks", {
      method: "POST",
      body: input,
    }),
  completeTask: (id: string) =>
    request<{ task: FollowUpTaskDto }>(`/follow-up-tasks/${id}/complete`, {
      method: "POST",
      body: {},
    }),
  reopenTask: (id: string) =>
    request<{ task: FollowUpTaskDto }>(`/follow-up-tasks/${id}/reopen`, {
      method: "POST",
      body: {},
    }),
};
